import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchUserServer } from "~/lib/services/user";

export const Route = createFileRoute("/dashboard")({
  component: Home,
  loader: async () => {},
});

function Home() {
  return (
    <div className="p-2">
      <h3>Welcome Home!!!</h3>
    </div>
  );
}
